export const formatCptCodesLabel = (cptCodes: string[] | null | undefined) => {
  const cleanCodes = (cptCodes ?? []).map(code => code.trim()).filter(Boolean);
  if (!cleanCodes.length) return null;

  const visibleCodes = cleanCodes.slice(0, 2).join(', ');
  const remainingCount = cleanCodes.length - 2;

  return remainingCount > 0 ? `CPT ${visibleCodes} +${remainingCount}` : `CPT ${visibleCodes}`;
};

export const formatBillingDefaultsLabel = (
  placeOfService: string | null | undefined,
  cptCodes: string[] | null | undefined,
  options: { emptyLabel?: string } = {},
) => {
  const parts = [
    placeOfService ? `POS ${placeOfService}` : null,
    formatCptCodesLabel(cptCodes),
  ].filter(Boolean);

  return parts.length ? parts.join(' · ') : (options.emptyLabel ?? 'No billing defaults');
};
